import { Tooltip, type TooltipProps } from '@fv/client-components'

type Props = Omit<TooltipProps, 'portalToRoot'>
export const CarrierTooltip = (props: Props) => {
  return (
    <Tooltip
      portalToRoot
      {...props}
      classNames={{
        popup:
          'pointer-events-none max-w-xs rounded-[0.3rem] border border-transparent bg-gray-800 px-3 py-2 text-xs text-white opacity-90',
        arrow: 'bg-gray-800',
        ...props.classNames,
      }}
    />
  )
}
